export const getUserToken = () => {
  return localStorage.getItem('access_token');
};
